import {z} from 'zod';

import {localeSchema} from '@dms/api/core';
import i18n from '@dms/i18n';
import {isEmailHtmlEmpty} from '@dms/shared';

/**
 * The values of the financing-ending compose form once its text is editable. `subject` and `body` are
 * a raw source with `{{ code }}` placeholders that the server renders for each recipient.
 * `templateId` and `locale` record the template the text started from; they are absent when the text
 * was written without one.
 *
 * The fields component takes the form's control as it is, and a control of a form with other fields
 * is not assignable to it, so the compose form uses this schema for its whole value.
 */
export const FinancingEndingEditableEmailFormSchema = z.object({
  emailCredentialsId: z.string().min(1),
  subject: z.string().trim().min(1, i18n.t('errors.field_is_required')),
  body: z.string().refine((body) => !isEmailHtmlEmpty(body), i18n.t('errors.field_is_required')),
  templateId: z.string().optional(),
  locale: localeSchema.optional(),
});

export type FinancingEndingEditableEmailFormValues = z.infer<
  typeof FinancingEndingEditableEmailFormSchema
>;
